<div class="row">
  <div class="col-md-5 counts-col-right">
    <div id="map" class="map-wraper"></div>
  </div>
  <div class="col-md-7 counts-col-left d-flex flex-column">
    <ul class="dept-srv-table p-0 m-0 w-100">
      <li class="dept-srv-table__row head p-2 w-100 d-flex align-items-center">
        <div class="dept-srv-table__col w-100">
          <label
            for=""
            style="font-family: $font-medium; justify-content: flex-start !important"
            class="mb-0"
            (click)="onSort('displayName', sortDirection)"
            >{{"stats.statut" | translate }}
            <mat-icon class="d-flex align-items-center" style="margin: 0"
              >unfold_more</mat-icon
            >
          </label>
        </div>
        <div class="dept-srv-table__col w-100">
          <label
            for=""
            style="font-weight: 600"
            class="mb-0 d-flex align-items-center"
            (click)="onSort('totalUser', sortDirection)"
            >{{'dashboardLang.users' | translate }}(K)
            <mat-icon class="d-flex align-items-center" style="margin: 0"
              >unfold_more</mat-icon
            ></label
          >
        </div>
        <div class="dept-srv-table__col w-100">
          <label
            for=""
            style="font-weight: 600"
            class="mb-0 d-flex align-items-center"
            (click)="onSort('departments', sortDirection)"
            >{{'benefits.applications' | translate }}
            <mat-icon class="d-flex align-items-center" style="margin: 0"
              >unfold_more</mat-icon
            ></label
          >
        </div>
        <div class="dept-srv-table__col w-100">
          <label
            for=""
            style="font-weight: 600"
            class="mb-0 d-flex align-items-center"
            (click)="onSort('services', sortDirection)"
            >{{'dept-details.services' | translate }}
            <mat-icon class="d-flex align-items-center" style="margin: 0"
              >unfold_more</mat-icon
            ></label
          >
        </div>
        <div class="dept-srv-table__col w-100">
          <label
            for=""
            style="font-weight: 600"
            class="mb-0 d-flex align-items-center"
            (click)="onSort('schemes', sortDirection)"
            >{{ 'global-search.schemes' | translate }}
            <mat-icon class="d-flex align-items-center" style="margin: 0"
              >unfold_more</mat-icon
            ></label
          >
        </div>
        <div class="dept-srv-table__col w-100">
          <label
            for=""
            style="font-weight: 600"
            class="mb-0 d-flex align-items-center"
            (click)="onSort('documents', sortDirection)"
            >{{'stats.documents' | translate }}
            <mat-icon class="d-flex align-items-center" style="margin: 0"
              >unfold_more</mat-icon
            ></label
          >
        </div>
      </li>
      <ng-container *ngFor="let item of filterList; let i = index">
        <li
          class="dept-srv-table__row p-2 w-100 d-flex flex-wrap"
          [id]="item.id"
          [style.background]="i % 2 == 0 ? '#005a9f1a' : ''"
          [ngClass]="{
            highlighted: i == 0 && currentState != 0 && !sortingApplied
          }"
        >
          <div class="dept-srv-table__col">
            <p class="mb-0" [title]="item?.displayName | titlecase">
              {{ item?.displayName | titlecase }}
            </p>
          </div>
          <div
            class="dept-srv-table__col"
            style="justify-content: flex-end !important"
          >
            <p class="mb-0">{{ item?.totalUser < 1000 ? '1K':getUsers(item?.totalUser, true) }}</p>
          </div>
          <div
            class="dept-srv-table__col"
            style="justify-content: flex-end !important"
          >
            <p class="mb-0">
              {{ item?.departments | number : "1.0-0" : "en-US" }}
            </p>
          </div>
          <div
            class="dept-srv-table__col"
            style="justify-content: flex-end !important"
          >
            <p class="mb-0">
              {{ item?.services | number : "1.0-0" : "en-US" }}
            </p>
          </div>
          <div
            class="dept-srv-table__col"
            style="justify-content: flex-end !important"
          >
            <p class="mb-0">{{ item?.schemes | number : "1.0-0" : "en-US" }}</p>
          </div>
          <div
            class="dept-srv-table__col"
            style="justify-content: flex-end !important"
          >
            <p class="mb-0">
              {{ item?.documents | number : "1.0-0" : "en-US" }}
            </p>
          </div>
        </li>
      </ng-container>
    </ul>
    <!-- <ul class="dept-srv-table p-0 m-0 w-100 pb-2">
      <li
        class="dept-srv-table__row bottom p-2 w-100 d-flex align-items-center"
      >
        <div class="dept-srv-table__col w-100">
          <label
            for=""
            style="text-align: left; justify-content: flex-start !important"
            class="mb-0"
            >{{'dashboardLang.totalCounts' | translate }}</label
          >
        </div>
        <div
          class="dept-srv-table__col w-100"
          style="justify-content: flex-end !important"
        >
          <label for="" class="mb-0">{{ getUsers(total.users) }}</label>
        </div>
        <div
          class="dept-srv-table__col w-100"
          style="justify-content: flex-end !important"
        >
          <label for="" class="mb-0">{{ getUsers(total.department) }}</label>
        </div>
        <div
          class="dept-srv-table__col w-100"
          style="justify-content: flex-end !important"
        >
          <label for="" class="mb-0">{{
            total.service | number : "1.0-0" : "en-US"
          }}</label>
        </div>
        <div
          class="dept-srv-table__col w-100"
          style="justify-content: flex-end !important"
        >
          <label for="" class="mb-0">{{
            total.schemes | number : "1.0-0" : "en-US"
          }}</label>
        </div>
        <div
          class="dept-srv-table__col w-100"
          style="justify-content: flex-end !important"
        >
          <label for="" class="mb-0">{{
            total.documents | number : "1.0-0" : "en-US"
          }}</label>
        </div>
      </li>
    </ul> -->
    <ul class="dept-srv-table p-0 m-0 w-100">
      <li
        class="dept-srv-table__row bottom p-2 w-100 d-flex align-items-center"
      >
        <div class="dept-srv-table__col w-100">
          <label
            for=""
            style="text-align: left; justify-content: flex-start !important"
            class="mb-0 d-flex align-items-center heading-icon"
            >{{'dashboardLang.center' | translate }}</label
          >
        </div>
        <div
          class="dept-srv-table__col w-100"
          style="justify-content: flex-end !important"
        >
          <label for="" class="mb-0"
            >*{{
              centerData?.totalUser ? getUsers(centerData?.totalUser) : "0"
            }}</label
          >
        </div>
        <div
          class="dept-srv-table__col w-100"
          style="justify-content: flex-end !important"
        >
          <label for="" class="mb-0">{{
            getUsers(centerData?.departments)
          }}</label>
        </div>
        <div
          class="dept-srv-table__col w-100"
          style="justify-content: flex-end !important"
        >
          <label for="" class="mb-0">{{
            getUsers(centerData?.services)
          }}</label>
        </div>
        <div
          class="dept-srv-table__col w-100"
          style="justify-content: flex-end !important"
        >
          <label for="" class="mb-0">{{ getUsers(centerData?.schemes) }}</label>
        </div>
        <div
          class="dept-srv-table__col w-100"
          style="justify-content: flex-end !important"
        >
          <label for="" class="mb-0">{{
            getUsers(centerData?.documents)
          }}</label>
        </div>
      </li>
    </ul>
    <div class="info-message show">
      *{{"dashboardLang.userNote" | translate }}
    </div>
  </div>
</div>
